import React from 'react';
import { UserCheck, Users, ClipboardList, BookOpen, Eye, CheckCircle2, ChevronRight } from 'lucide-react';

export const JOURNEE_PAGES = [
  { key: 'presences', label: 'Gestion des présences', desc: 'Présents, retards, absences, émargement', icon: UserCheck, color: 'emerald' },
  { key: 'modules_candidats', label: 'Modules par candidat', desc: 'Dispatch individuel des modules du jour', icon: Users, color: 'violet' },
  { key: 'deroule', label: 'Déroulé pédagogique', desc: 'Notes, exercices, cas pratique, observations du groupe, note interne', icon: ClipboardList, color: 'sky' },
  { key: 'evaluations', label: 'Évaluations', desc: 'QCM et évaluations libres', icon: BookOpen, color: 'amber' },
  { key: 'observations', label: 'Observations candidats', desc: 'Observations individuelles du formateur', icon: Eye, color: 'rose' },
];

const COLORS = {
  emerald: 'bg-emerald-50 text-emerald-600 group-hover:bg-emerald-100',
  violet: 'bg-violet-50 text-violet-600 group-hover:bg-violet-100',
  sky: 'bg-sky-50 text-sky-600 group-hover:bg-sky-100',
  amber: 'bg-amber-50 text-amber-600 group-hover:bg-amber-100',
  rose: 'bg-rose-50 text-rose-600 group-hover:bg-rose-100',
};

// Indique si chaque page a été renseignée (badge « Saisi »)
export const computeSaisi = (cahier, hasEvaluation) => ({
  presences: !!cahier.presences_validees,
  modules_candidats: (cahier.dispatch_modules || []).length > 0,
  deroule: !!((cahier.deroule || '').trim() || (cahier.exercices || '').trim() || (cahier.cas_pratique || '').trim() || (cahier.observations_groupe || '').trim() || (cahier.actions_preconisations || '').trim()),
  evaluations: !!hasEvaluation,
  observations: (cahier.observations_candidats || []).some(o => (o.texte || '').trim()),
});

export const JourneeMenu = ({ saisi, onOpen, resume, locked }) => (
  <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 ${locked ? 'opacity-50' : ''}`} data-testid="journee-menu" data-locked={locked ? 'true' : 'false'}>
    {JOURNEE_PAGES.map(p => {
      const Icon = p.icon;
      const done = saisi[p.key];
      return (
        <button type="button" key={p.key} onClick={() => onOpen(p.key)} data-testid={`menu-${p.key}`} disabled={locked}
          title={locked ? 'Confirmez d\'abord les modules de la journée' : undefined}
          className={`group text-left rounded-xl border bg-white p-4 transition-all ${locked ? 'cursor-not-allowed' : 'hover:-translate-y-0.5 hover:shadow-md'} ${done ? 'border-emerald-200' : 'border-slate-200'}`}>
          <div className="flex items-start justify-between gap-2">
            <span className={`inline-flex w-9 h-9 rounded-lg items-center justify-center transition-colors ${COLORS[p.color]}`}><Icon className="w-4.5 h-4.5 w-5 h-5" /></span>
            {done ? (
              <span className="inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700" data-testid={`saisi-${p.key}`}><CheckCircle2 className="w-3 h-3" /> Saisi</span>
            ) : (
              <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-slate-100 text-slate-500" data-testid={`a-saisir-${p.key}`}>À saisir</span>
            )}
          </div>
          <p className="mt-3 text-sm font-semibold text-slate-800 leading-tight">{p.label}</p>
          <p className="text-[11px] text-slate-500 mt-0.5 leading-snug">{resume?.[p.key] || p.desc}</p>
          {p.key === 'evaluations' && resume?.evaluations && <p className="text-[11px] text-slate-500 mt-0.5 leading-snug">{p.desc}</p>}
          <span className="mt-2 inline-flex items-center text-[11px] font-medium text-indigo-600">Ouvrir <ChevronRight className="w-3 h-3 ml-0.5 transition-transform group-hover:translate-x-0.5" /></span>
        </button>
      );
    })}
  </div>
);
